/**
 * Converts a hexadecimal color code to RGBA format.
 * @param {string} hexCode - The hexadecimal color code to convert.
 * @returns {string} - The RGBA color string.
 */
export const convertHexToRGBA = (hexCode) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hexCode)) {
    c = hexCode.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = `0x${c.join("")}`;
    // eslint-disable-next-line no-bitwise
    return `rgba(${(c >> 16) & 255}, ${(c >> 8) & 255}, ${c & 255}, 1)`;
  }
  throw new Error("Bad Hex");
};

/**
 * This function takes a hex color code (e.g., "#FFFFFF") and an opacity percentage (e.g., "50"),
 * and converts them into an rgba color (e.g., "rgba(255,255,255,0.5)").
 *
 * @param {string} hexCode - The hexadecimal color code to be converted.
 * @param {string} opacityPercentage - The opacity value as a percentage to be applied to the color.
 * @returns {string|null} The resulting rgba color string, or null if inputs are invalid.
 */
export const convertHexAndOpacityToRGBA = (hexCode, opacityPercentage) => {
  if (!hexCode || !opacityPercentage) return null;

  let rgbaColor = convertHexToRGBA(hexCode);
  const opacityValue = parseFloat(opacityPercentage) / 100;
  rgbaColor = `${rgbaColor.substring(0, rgbaColor.lastIndexOf(","))}, ${opacityValue})`;
  return rgbaColor;
};

/**
 * Updates the background color of an element via CSS selector.
 * This function queries the DOM using the provided selector. If it exists and has
 * `data-background` and `data-opacity` attributes, it calculates a new background color in RGBA format
 * using these values. This is neccessary to preview the updating of styles in the theme editor.
 *
 * @param {string} selector - The CSS selector used to find the element whose background color needs updating.
 *                            The function expects this element to have `data-background` and `data-opacity`.
 */
function updateBackgroundColor(selector) {
  const element = document.querySelector(selector);
  if (element && element.dataset.background && element.dataset.opacity) {
    const newBackgroundColor = convertHexAndOpacityToRGBA(
      element.dataset.background,
      element.dataset.opacity,
    );
    if (newBackgroundColor) {
      element.style.backgroundColor = newBackgroundColor;
    }
  }
}

updateBackgroundColor("#desktop-banner .content-wrapper");

/**
 * Sets up an event listener to update content opacity when previewing changes in the Shopify theme editor.
 * This ensures that any changes made to elements with a specific class are reflected immediately
 * in the theme editor.
 */
if (window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    updateBackgroundColor("#desktop-banner .content-wrapper");
  });
}

// Tracking
document.addEventListener("DOMContentLoaded", function () {
  const cta1 = document.querySelectorAll("[data-hph1-cta1]")[0];
  const cta2 = document.querySelectorAll("[data-hph1-cta2]")[0];
  const desktopImage = document.querySelectorAll(".hero-with-text-dsktp")[0];
  const imageContainers = document.querySelectorAll(
    "[data-hph1-image-container]",
  );

  cta1?.addEventListener("click", () => {
    gtag({
      event: "HPH1_primary_cta_click",
      eventData: {
        image: desktopImage?.src,
        ctaText: cta1?.text?.trim(),
        ctaURL: cta1?.href,
      },
    });
  });

  cta2?.addEventListener("click", () => {
    gtag({
      event: "HPH1_secondary_cta_click",
      eventData: {
        image: desktopImage?.src,
        ctaText: cta2?.text?.trim(),
        ctaURL: cta2?.href,
      },
    });
  });

  imageContainers.forEach((container) => {
    container.addEventListener("click", () => {
      const imageSrc = container.querySelector("img").src;
      gtag({
        event: "HPH1_image_click",
        eventData: {
          image: imageSrc,
          ctaURL: container.href,
        },
      });
    });
  });
});
